import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getPartners = () =>
  axiosInstance.get(`${LANDING_API_URL}/partners`, {
    headers: authHeaders(),
  });

export const createPartnerRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/partners`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updatePartnerRequest = (partnerId, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/partners/${partnerId}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removePartner = (partnerId) =>
  axiosInstance.delete(`${LANDING_API_URL}/partners/${partnerId}`, {
    headers: authHeaders(),
  });
